import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=a1aaecb2&scoped=true"
import script from "./Myorder.vue?vue&type=script&lang=js"
export * from "./Myorder.vue?vue&type=script&lang=js"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=a1aaecb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1aaecb2",
  null
  
)

export default component.exports